import { BookCard, Box, useTheme } from '@hermes/web-components'

import BaseModal from '@components/BaseModal'
import BookImage from '@components/BookImage'
import { BookDto, MeiliConsolidatedBookDto } from '@hermes/domains'
import { useNavigation } from '@hooks/useNavigation'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { getVersionPriceLabel } from '@lib/utils/meiliResultHelpers'

interface BookVersionsModalProps {
  isOpen: boolean
  onClose: () => void
  versions: MeiliConsolidatedBookDto['books'][number][] | BookDto['versions']
}

type MeiliBookVariant = MeiliConsolidatedBookDto['books'][number]

const isMeiliVariant = (version: any): version is MeiliBookVariant =>
  Array.isArray(version.languages) && (version.languages.length === 0 || typeof version.languages[0] === 'string')

export const BookVersionsModal = ({ isOpen, onClose, versions }: BookVersionsModalProps) => {
  const { t } = useTranslateMessage()
  const theme = useTheme()
  const { navigate } = useNavigation()

  if (!versions) return null

  return (
    <BaseModal isOpen={isOpen} width={438} onClose={onClose} title={t({ id: 'versions' })}>
      <Box
        sx={{
          padding: '0px 12px 12px',
          maxHeight: '70vh',
          overflowY: 'auto',
          '.list-version-item': {
            borderBottom: `1px solid ${theme.palette.divider}`,
            '&:last-child': {
              borderBottom: 'none'
            }
          }
        }}
      >
        {versions.map((version) => {
          const isVariant = isMeiliVariant(version)

          return (
            <Box className="list-version-item" key={version.id}>
              <BookCard
                inline
                title={`${version.title}`}
                cover={t({ id: version.format })}
                year={String(version.year)}
                chipLabel={
                  isVariant
                    ? getVersionPriceLabel(version) || t({ id: 'common.sold_out', defaultMessage: 'Sold out' })
                    : ''
                }
                chipDisabled={isVariant ? getVersionPriceLabel(version) === null : false}
                globalAction={() => {
                  navigate.productPage(version.slug)
                  onClose()
                }}
                image={<BookImage src={version.smallImage} width={40} height={56} alt={version.title} />}
                hover
              />
            </Box>
          )
        })}
      </Box>
    </BaseModal>
  )
}
